import { type Chart, type TooltipModel } from "chart.js";

export function chartTooltip({
  chart,
  tooltip,
}: {
  chart: Chart;
  tooltip: TooltipModel<"pie">;
}) {
  let tooltipEl = document.getElementById("pie-chart-tooltip");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = "pie-chart-tooltip";
    tooltipEl.style.position = "absolute";
    tooltipEl.style.pointerEvents = "none";
    tooltipEl.style.zIndex = "10000";
    document.body.appendChild(tooltipEl);
  }

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = "0";
    tooltipEl.style.transition = "opacity 0.1s ease-out";
    return;
  }

  if (tooltip.body) {
    const lines = tooltip.body.flatMap((b) => b.lines);
    const innerHtml = tooltipContent(tooltip, lines);
    tooltipEl.innerHTML = innerHtml;
  }

  const position = chart.canvas.getBoundingClientRect();
  const tooltipElRect = tooltipEl.getBoundingClientRect();

  let left = position.left + window.scrollX + tooltip.caretX;
  left -= tooltipElRect.width / 2;

  if (left < 0) {
    left = 5;
  }

  if (left + tooltipElRect.width > window.innerWidth) {
    left = window.innerWidth - tooltipElRect.width - 5;
  }

  const top =
    position.top + window.scrollY + tooltip.caretY - tooltipElRect.height - 10;

  tooltipEl.style.opacity = "1";
  tooltipEl.style.left = `${left}px`;
  tooltipEl.style.top = `${top}px`;
  tooltipEl.style.transition = "opacity 0.1s ease-in";
}

function tooltipContent(tooltip: TooltipModel<"pie">, lines: string[]): string {
  const fullContentHtml = `
    <div class="bg-v2-secondary rounded-md shadow-lg text-xs p-2">
      <div class="bg-v2-primary rounded-md overflow-hidden border border-v2-tertiary">
        <div class="px-3 py-2">
          ${lines.join("")}
        </div>
      </div>
    </div>
  `;

  return fullContentHtml;
}
